
import React from 'react'

import type { Company } from 'types'

import { Box, Stack, Typography, Avatar, useTheme } from '@mui/material'

import { Preview } from 'components'
import { Building2 } from 'lucide-react'



interface CustomerPreviewProps {
  company: Company | null | undefined
  onChange?: any,
  onRemove?: any,
  disabled?: boolean
  size?: 'small' | 'medium' | 'large'
}

export const CompanyPreview = (props: CustomerPreviewProps) => {
  const { company, onChange = false, onRemove = false, disabled = false, size = 'large'} = props
  const { logo, name } = company || {}
  const theme = useTheme()

  if (!company) return null

  return (
    <Preview size={size} item={company} onRemove={onRemove} onChange={onChange} disabled={disabled}>
      <Box p="12px" sx={theme => ({ border: `1px solid ${theme.palette.grey[300]}` })}>
        <Stack spacing="16px" direction="row" alignItems="center" sx={{ minWidth: 0, maxWidth: size == 'small' ? 100 : '100%' }}>
          <Avatar
            src={logo}
            alt={name}
            sx={{
              width: 40,
              height: 40,
              bgcolor: !logo ? theme.palette.grey[50] : undefined,
              border: !logo ? `1px solid ${theme.palette.grey[200]}` : undefined
            }}
          >
            {!logo && (
              <Building2 strokeWidth={1} size={20} color={theme.palette.grey[400]} />
            )}
          </Avatar>
          <Typography variant="body2" noWrap>
            {name}
          </Typography>
        </Stack>
      </Box>
    </Preview>
  )
}
